import {
  WORKER_FETCH_REQUEST, WORKER_FETCH_SUCCESS, WORKER_FETCH_FAILURE, WORKER_DETAIL,
  ATTENDANCE_FETCH_REQUEST, ATTENDANCE_FETCH_SUCCESS, ATTENDANCE_FETCH_FAILURE,
  ADVANCE_FETCH_REQUEST, ADVANCE_FETCH_SUCCESS, ADVANCE_FETCH_FAILURE,
  SALARY_FETCH_REQUEST, SALARY_FETCH_SUCCESS, SALARY_FETCH_FAILURE,
} from "../types/HrTypes";

// ── Workers ───────────────────────────────────────────────────────────
const workerInit = { list: [], total: 0, loading: false, worker: null };
export const workerReducer = (state = workerInit, action) => {
  switch (action.type) {
    case WORKER_FETCH_REQUEST:
      return { ...state, loading: true };
    case WORKER_FETCH_SUCCESS:
      // action.payload = { getAllWorker, totalWorker } or plain array
      if (Array.isArray(action.payload)) {
        return { ...state, loading: false, list: action.payload, total: action.payload.length };
      }
      return { ...state, loading: false, list: action.payload.getAllWorker || [], total: action.payload.totalWorker || 0 };
    case WORKER_FETCH_FAILURE:
      return { ...state, loading: false };
    case WORKER_DETAIL:
      return { ...state, worker: action.payload };
    default:
      return state;
  }
};

// ── Attendance ────────────────────────────────────────────────────────
const attInit = { list: [], loading: false };
export const attendanceReducer = (state = attInit, action) => {
  switch (action.type) {
    case ATTENDANCE_FETCH_REQUEST:
      return { ...state, loading: true };
    case ATTENDANCE_FETCH_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case ATTENDANCE_FETCH_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

// ── Advances ──────────────────────────────────────────────────────────
const advInit = { list: [], total: 0, loading: false };
export const advanceReducer = (state = advInit, action) => {
  switch (action.type) {
    case ADVANCE_FETCH_REQUEST:
      return { ...state, loading: true };
    case ADVANCE_FETCH_SUCCESS:
      if (Array.isArray(action.payload)) {
        return { ...state, loading: false, list: action.payload, total: action.payload.length };
      }
      return { ...state, loading: false, list: action.payload.getAllAdvance || [], total: action.payload.totalAdvance || 0 };
    case ADVANCE_FETCH_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

// ── Salary ────────────────────────────────────────────────────────────
const salInit = { sheet: null, loading: false };
export const salaryReducer = (state = salInit, action) => {
  switch (action.type) {
    case SALARY_FETCH_REQUEST:
      return { ...state, loading: true, sheet: null };
    case SALARY_FETCH_SUCCESS:
      return { ...state, loading: false, sheet: action.payload };
    case SALARY_FETCH_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};
